import PropTypes from "prop-types";

import FieldLabel from "../FieldLabel";
import FieldValue from "../FieldValue";

const Field = ({ field, labelText, customClassName, labelVariant, labelComponent, invite }) => {
  return (
    <>
      {labelText && (
        <FieldLabel
          field={field}
          text={labelText}
          variant={labelVariant}
          component={labelComponent}
          customClassName={customClassName}
        />
      )}
      <FieldValue field={field} invite={invite} />
    </>
  );
};

Field.propTypes = {
  field: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  customClassName: PropTypes.string,
  labelVariant: PropTypes.string,
  labelComponent: PropTypes.string,
  invite: PropTypes.shape(),
};

export default Field;
